/* eslint-disable react/prop-types */
import React from 'react';
import { Modal } from 'antd';
import UserForm from 'components/Form/UserForm/UserForm';
import './ModalUser.scss';

// eslint-disable-next-line react/prop-types
function ModalUser({ open, callback, user, estados, cmonitoreos, rolName }) {
  const handleCancel = () => {
    callback(false);
  };

  return (
    <Modal
      title="Editar usuario"
      open={open}
      onCancel={handleCancel}
      centered
      width="85%"
      wrapClassName="modal-simac"
      className="modal-user"
      footer={null}>
      <UserForm
        user={user}
        estados={estados}
        cmonitoreos={cmonitoreos}
        rolName={rolName}
        callback={callback}
      />
    </Modal>
  );
}

export default ModalUser;
